import { getDoraRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';

export const getDoraAnalyticsRoot = (state: ApplicationState) => getDoraRoot(state).analytics;
export const getDoraDataManagementRoot = (state: ApplicationState) => getDoraRoot(state).dataManagement;
export const getDoraFunctionsRoot = (state: ApplicationState) => getDoraRoot(state).functions;
export const getDoraCompaniesRoot = (state: ApplicationState) => getDoraRoot(state).myCompanies;
export const getDoraReportingRoot = (state: ApplicationState) => getDoraRoot(state).reporting;
export const getDoraSupplyChainRoot = (state: ApplicationState) => getDoraRoot(state).supplyChain;
export const getDoraThirdPartyRoot = (state: ApplicationState) => getDoraRoot(state).thirdParty;
